module.exports = __webpack_public_path__ + "img/統計学入門_1_1_問題.9d3e0125.png";